import { gql } from '@apollo/client';

export const CONTRACTOR_CREATE = gql`
  mutation ContractorCreate(
    $name: String!
    $ceo: String
    $phone: String
    $email: String!
    $webSite: String
    $about: String
    $logo: String
    $photos: [String!]
    $recommendedBy: [String!]
    $specifications: JSON
  ) {
    contractorCreate(
      name: $name
      ceo: $ceo
      phone: $phone
      email: $email
      webSite: $webSite
      about: $about
      logo: $logo
      photos: $photos
      recommendedBy: $recommendedBy
      specifications: $specifications
    ) {
      id
      name
      ceo
      about
      logo
      photos
      recommendedBy
      specifications
    }
  }
`;

export const CONTRACTOR_UPDATE = gql`
  mutation ContractorUpdate(
    $id: ID!
    $name: String!
    $phone: String
    $email: String!
    $webSite: String
    $ceo: String
    $about: String
    $logo: String
    $photos: [String!]
    $recommendedBy: [String!]
    $specifications: JSON
  ) {
    contractorUpdate(
      id: $id
      name: $name
      phone: $phone
      email: $email
      webSite: $webSite
      ceo: $ceo
      about: $about
      logo: $logo
      photos: $photos
      recommendedBy: $recommendedBy
      specifications: $specifications
    ) {
      id
      name
      ceo
      about
      logo
      photos
      recommendedBy
      specifications
    }
  }
`;

export const CONTRACTOR_DELETE = gql`
  mutation RemoveContractor($id: ID!) {
    removeContractor(id: $id)
  }
`;
